// src/lib/opportunity/proposalTextClient.ts
//
// Browser-side client for the proposal text override endpoints (opp
// engine iter 2 slice C). Three operations: list (read all overrides
// for the active org or a filtered subset), upsert (save one section),
// delete (revert one section to its default).

import { opportunityFetch } from "./opportunityFetch";
import type { OpportunityFormatKey } from "@/types/opportunity";
import type { ProposalTextSectionKey } from "./proposalTextSections";

export type ProposalTextOverride = {
  id: string;
  organization_id: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  section_key: ProposalTextSectionKey;
  body: string;
  included: boolean;
  updated_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

export type ListProposalTextOverridesFilters = {
  format_key?: OpportunityFormatKey;
  product_type?: string;
};

export function listProposalTextOverrides(
  filters: ListProposalTextOverridesFilters = {},
) {
  const q = new URLSearchParams();
  if (filters.format_key) q.set("format_key", filters.format_key);
  if (filters.product_type) q.set("product_type", filters.product_type);
  const qs = q.toString();
  const path = qs
    ? `/api/opportunity/proposal-text-list?${qs}`
    : "/api/opportunity/proposal-text-list";
  return opportunityFetch<{ ok: true; overrides: ProposalTextOverride[] }>(path, {
    method: "GET",
  });
}

export type UpsertProposalTextOverridePayload = {
  format_key: OpportunityFormatKey;
  product_type: string;
  section_key: ProposalTextSectionKey;
  body: string;
  included?: boolean;
};

export function upsertProposalTextOverride(
  payload: UpsertProposalTextOverridePayload,
) {
  return opportunityFetch<{ ok: true; override: ProposalTextOverride }>(
    "/api/opportunity/proposal-text-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export type DeleteProposalTextOverridePayload = {
  format_key: OpportunityFormatKey;
  product_type: string;
  section_key: ProposalTextSectionKey;
};

export function deleteProposalTextOverride(
  payload: DeleteProposalTextOverridePayload,
) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/proposal-text-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
